<template>
  <div class="main">
    <mt-header
      :title="$t('NFT历史记录')"
      class="dl_header_white dl_line_bottom"
      fixed
    >
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="mainbody">
      <div class="historyitem">
        <!-- <span
          v-for="(item, index) in nftitem"
          :key="index"
          :class="[item.value == chooseitem ? 'darkstyle' : '']"
          @click="chooseitem = item.value"
          >{{ item.name }}</span
        > -->
      </div>
      <NftHistoryList :alive="isalive"></NftHistoryList>
      <!-- <NftHistoryList
        :nftvalue="chooseitem"
        v-show="chooseitem == 0"
        :shownft="0"
      ></NftHistoryList>
      <NftHistoryList
        v-show="chooseitem == 1"
        :nftvalue="chooseitem"
        :shownft="1"
      ></NftHistoryList>
      <NftHistoryList
        v-show="chooseitem == 2"
        :nftvalue="chooseitem"
        :shownft="2"
      ></NftHistoryList> -->
    </div>
  </div>
</template>
<script>
import NftHistoryList from "../../components/NftHistoryList.vue";
export default {
  components: { NftHistoryList },
  beforeRouteLeave(to, form, next) {
    if (to.path == "/nfthistoryinfo") {
      this.isalive = true;
    } else {
      this.isalive = false;
    }
    next();
  },

  data() {
    return {
      isalive: false,
      // nftitem: [
      //   { name: "全部", value: 0 },
      //   { name: "转入", value: 1 },
      //   { name: "转出", value: 2 },
      // ],
      // chooseitem: 0,
    };
  },
};
</script>
<style scoped>
.dl_header_white {
  border-bottom: 1px solid #e5e5e5;
}
.mainbody {
  padding: 40px 13px 0;
}
.historyitem {
  /* margin-top: 15px; */
  font-size: 12px;
  color: #666666;
}
.historyitem span {
  margin-right: 30px;
}
.darkstyle {
  color: #000000;
  /* font-weight: bold; */
}
.nfthistory {
  margin-top: 10px;
}
.nftitem {
  margin: 14px 0;
}
</style>
